import React, { FC } from "react";
import { LabelStyled } from "./elements";

type LabelProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: any;
};

const Label: FC<LabelProps> = (props) => {
  const { children, style, onClick } = props;

  return <LabelStyled onClick={onClick} style={style}>{children}</LabelStyled>;
};

export default Label;
